import { render, staticRenderFns } from "./TgHomeE32021.vue?vue&type=template&id=592153d6&"
import script from "./TgHomeE32021.vue?vue&type=script&lang=js&"
export * from "./TgHomeE32021.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports